import React from "react"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import ParkMap from "../../components/parkmap"

const ParkPage = () => {
  return (
    <Layout>
      <SEO title="Parks and Facilities" />
      <div className="title-section centered">
        <h1 className="title is-size-1">Parks and Facilities</h1>
        <center>
          <p className="is-size-5">See map of parks and ponds below. Click a pin for more info.</p>
        </center>
      </div>

      <div style={{ marginTop: '4rem' }}>
        <ParkMap />
      </div>
    </Layout>
  )
}

export default ParkPage

